import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getNortonAccount,
  getNortonAccountPending,
  getProducts,
} from '../../store/reducers';
import { TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { GetNortonAccount } from '../store/actions/norton.actions';

@Component({
  selector: 'mprd-norton-family-download',
  templateUrl: './norton-family-download.component.html',
})
export class NortonFamilyDownloadComponent
  extends OnDestroyHookDirective
  implements OnInit {
  downloadLink: string;
  key: string;
  isPending = true;
  dataLoaded = false;

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNortonAccount).subscribe((value) => {
        this.key = value?.nortonAccount?.pin;
        this.computeDownloadLink(this.key);
      }),
    );

    this.addSubscription(
      this.store.select(getNortonAccountPending).subscribe((value) => {
        this.isPending = value;
      }),
    );

    this.addSubscription(
      this.store.select(getProducts)?.subscribe((products) => {
        if (products && products.length > 0 && !this.dataLoaded) {
          this.dataLoaded = true;
          const ssids = products.filter((p) => p.groupMpcUuid === this.translationService.getTranslatedValueFor('norton.subscription.nortonFamilyMpcUuid')).map((product) => product.accessNumber);
          if (ssids.length > 0) {
            const payload = {
              ssids,
            };
            this.store.dispatch(new GetNortonAccount(payload));
          }
        }
      }),
    );
  }

  private computeDownloadLink(key: string) {
    this.downloadLink = this.translationService
      .getTranslatedValueFor('nortonFamily.details.download.link')
      .replace(/\{0\}/g, key || '');
  }
}
